module.exports = __webpack_public_path__ + "static/media/img.filter5.advanced.66f78ccf.svg";